import type { SnapshotFrom } from 'xstate'
import type { emergencyMachine, EmergencyContext } from './machine'

type EmergencySnapshot = SnapshotFrom<typeof emergencyMachine>

/**
 * Selectors for stable reads from the emergency state machine snapshot.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const selectAudioState = emergencySelectors.isAudioPlaying
 * ```
 */
export const emergencySelectors = {
  context: (snapshot: EmergencySnapshot): EmergencyContext => snapshot.context,
  currentState: (snapshot: EmergencySnapshot) => snapshot.value,
  isAudioPlaying: (snapshot: EmergencySnapshot) => snapshot.context.isAudioPlaying,
}
